module.exports = __webpack_public_path__ + "img/kiran_mazumdar_shaw.e811929c.jpg";